import * as CronofyElements from "cronofy-elements";
import { useEffect } from "react";
import { useState } from "react";
import { useTheme } from "@mui/material";

export const AvailabilityRulesWrapper = ({ options }) => {
  const [element, setElement] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    if (!element && options.element_token) {
      setElement(CronofyElements.AvailabilityRules(options));
    }
  }, []);

  useEffect(() => {
    if (element && options.element_token) {
      element.update(options);
    }
  }, [options]);

  // Apply dark/light theme to the Cronofy widget DOM
  useEffect(() => {
    const target = document.getElementById(options?.target_id);
    if (!target) return;

    const isDark = theme.palette.mode === "dark";
    const textColor = theme.palette.text.primary;
    const bgColor = theme.palette.background.paper;
    const borderColor = isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)";
    const inputBg = isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)";
    const secondaryText = theme.palette.text.secondary;

    const applyTheme = () => {
      target.querySelectorAll("p, span, label, h1, h2, h3, h4, h5, h6").forEach((el) => {
        el.style.color = textColor;
      });

      target.querySelectorAll("[class*='helper'], [class*='secondary'], [class*='caption']").forEach((el) => {
        el.style.color = secondaryText;
      });

      target.querySelectorAll("button").forEach((btn) => {
        btn.style.color = textColor;
        btn.style.borderColor = borderColor;
      });

      target.querySelectorAll("div[class]").forEach((el) => {
        el.style.color = textColor;
        if (el.style.backgroundColor && el.style.backgroundColor !== "transparent") {
          el.style.backgroundColor = bgColor;
        }
        if (el.style.borderColor) el.style.borderColor = borderColor;
      });

      target.querySelectorAll("input, select, textarea").forEach((el) => {
        el.style.color = textColor;
        el.style.backgroundColor = inputBg;
        el.style.borderColor = borderColor;
      });

      target.querySelectorAll("a").forEach((el) => {
        el.style.color = theme.palette.primary.main;
      });
    };

    applyTheme();
    const observer = new MutationObserver(applyTheme);
    observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"] });
    return () => observer.disconnect();
  }, [options?.target_id, theme.palette.mode, theme.palette.text.primary, theme.palette.background.paper, theme.palette.primary.main]);

  return <div id={options?.target_id} />;
};
